import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ChevronLeftIconProps = Partial<SVGIconProps>;

const ChevronLeftIcon: FC<ChevronLeftIconProps> = (props) => (
  <SVGIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M15.0001 19.92L8.48009 13.4C7.71009 12.63 7.71009 11.37 8.48009 10.6L15.0001 4.08"
      stroke="#292D32"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </SVGIcon>
);

export default ChevronLeftIcon;
